import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PinHtmlEditorComponent } from './components/pin-html-editor/pin-html-editor.component';
import { FormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';

// Option 1 [ TinyMCE ]
import { EditorModule } from '@tinymce/tinymce-angular';
// Option 2 [ Primeng & quill editor ]
// import {EditorModule} from 'primeng/editor';


@NgModule({
  declarations: [PinHtmlEditorComponent],
  imports: [
    CommonModule,
    FormsModule,
    // Option 1 [ TinyMCE ]
      EditorModule,
    // Option 2 [ Primeng & quill editor ]
    //  EditorModule
  ],
  exports:[PinHtmlEditorComponent]
})
export class PinHtmlEditorModule { 
  @Input() data: string; // Input for the editor's content

  // Method to get the live content
  getContent(): string {
    return this.data; // Return the live content
  }
}
